import React from '../helpers/react';
import {openProblemById} from '../actions/problem.action.js';
import Problem from '../components/Problem.js';
import {connect} from '../helpers/composeReducer.js';

export const SingleSolution = React.createClass({
    componentWillMount : function(){
        this.props.openProblemById(this.props.id || this.props.params.id);
    },
    render : function(){
        return <Problem />
    }
});

export default connect(null, {openProblemById})(SingleSolution);


// WEBPACK FOOTER //
// ./src/containers/SingleSolution.js